"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeValuableItem = void 0;
class AnnualHomeValuableItem {
}
exports.AnnualHomeValuableItem = AnnualHomeValuableItem;
//# sourceMappingURL=AnnualHomeValuableItem.js.map